import { nanoid } from "@scalar-org/entities/utility";
import { buildChildAttributes } from "../../helpers/build-child-attributes.js";
import { html } from "../../helpers/html-template.js";
import { validate } from "../../helpers/validate.js";
import { EditorClasses } from "../../styles.js";
import {
  attributesCodeGroupSchema
} from "./attributes.js";
const scalarCodeGroup = {
  name: "scalar-code-group",
  tagName: "scalar-code-group",
  tiptapName: "scalar-code-group",
  attributeTransform: (_content, _props, node) => {
    return validate(attributesCodeGroupSchema, {
      children: buildChildAttributes({ node, filterTagName: "scalar-code" })
    });
  },
  render: async (props) => {
    const uid = nanoid();
    const tabGroupName = `code-group-input-${uid}`;
    const inputs = props.children.map((child, index) => {
      return html`
        <input
          id="${child.id || ""}"
          class="code-group-input sr-only"
          name="${tabGroupName}"
          ${index === 0 ? "checked" : ""}
          type="radio"
          value="${index}" />
      `;
    }).join("");
    const labels = props.children.map((child, index) => {
      return html`
        <label
          class="code-group-label"
          for="${child.id || ""}"
          >${`${child.title || child.lang || `Tab ${index + 1}`}`}</label
        >
      `;
    }).join("");
    return html`
<div class="${EditorClasses.CodeGroup}">
  ${inputs}
  <nav class="code-group-nav">
    ${labels}
  </nav>

  <ssg-children></ssg-children>
</div>
    `;
  }
};
export {
  scalarCodeGroup
};
//# sourceMappingURL=index.js.map
